module.exports = __webpack_public_path__ + "static/img/introduction-barometer-ethics.430afc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-barometer-ethics.jpg
// module id = xM/Y
// module chunks = 0